import React, {useState, useRef, useEffect} from 'react'
import moment from 'moment'
import {Typography} from '@material-ui/core'
import CreateIcon from '@material-ui/icons/Create'
import './EditableDateText.scss'

const EditableDateText = ({
  onChange,
  value,
  date_format,
  time_format,
  format = `${date_format} ${time_format}`,
}) => {
  const [edit, setEdit] = useState(false)
  const [editValue, setEditValue] = useState('')
  const refText = useRef(null)
  const handleClickEdit = e => {
    setEdit(true)
    if (value !== null) {
      setEditValue(value.format(format))
    }
  }

  const handleChange = e => {
    if (moment(e.target.value).isValid() === true) {
      onChange(e, moment(e.target.value))
    } else if (e.target.value === '') {
      onChange(e, null)
    }
    setEdit(false)
  }

  useEffect(() => {
    if (edit) {
      refText.current.focus()
    }
  }, [edit])

  return (
    <>
      <div
        style={{display: edit ? 'none' : null}}
        className="c-editable-date-text"
        onClick={handleClickEdit}
      >
        <Typography className="c-editable-date-text__text ap-typography ap-typography--sm">
          {value !== null ? moment(value).format(format) : 'Add Date'}
        </Typography>
        <CreateIcon className="c-editable-date-text__edit-icon" />
      </div>
      <input
        ref={refText}
        style={{display: !edit ? 'none' : 'block'}}
        value={editValue}
        onChange={e => setEditValue(e.target.value)}
        className="c-editable-date-text__textfield c-editable-date-text__text ap-typography ap-typography--sm"
        placeholder={format}
        onBlur={handleChange}
      />
    </>
  )
}

export default EditableDateText
